if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {

  let form_id_4162 = document.querySelector( "#form_id-4162" )
  if( form_id_4162 ){
    let yes_signup = form_id_4162.querySelector( "#form_id-4162-yes-signup-formemail-signup" )
    yes_signup.classList.add( "required" )
  }

  /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );

  $(".btn").append(
    '<div class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20.83194" height="12.86377" viewBox="0 0 20.83194 12.86377"><polygon points="20.14 5.951 12.005 0 11.437 0.776 18.511 5.951 0 5.951 0 6.913 18.511 6.913 11.437 12.087 12.005 12.864 20.14 6.913 20.832 6.432 20.14 5.951"/></svg></div>'
  );

  $(".sym-slides").slick({
    accessibility: true,
  });

  $(".slider-simple-events").slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 500,
    fade: true,
    accessibility: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          adaptiveHeight: true,
          autoplay: false,
        },
      },
    ],
  });


  $(".images-slides").slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 500,
    fade: true,
    accessibility: true,
  });

  $(".images-slides figure").attr("aria-hidden", false);

  $(".reviews-slides").slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 7000,
    speed: 500,
    fade: true,
    accessibility: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          adaptiveHeight: true,
          autoplay: false,
        },
      },
    ],
  });

  $(".gallery-slider").slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 700,
    accessibility: true,
    slidesToShow: 1,
    variableWidth: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          variableWidth: false,
          centerMode: false,
          adaptiveHeight: true,
        },
      },
    ],
  });

  $(".counter-slider").slick({
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 700,
    fade: true,
    accessibility: true,
  });

  $(".slider-info").slick({
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 700,
    accessibility: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          variableWidth: false,
          adaptiveHeight: true,
        },
      },
    ],
  });

  $(".blog-container-slider").slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 700,
    fade: true,
    accessibility: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          arrows: false,
          dots: true,
          adaptiveHeight: true,
        },
      },
    ],
  });

  let menu1 = document.querySelectorAll(".menus-site");
  if (menu1 != null) {
    menu1.forEach((i, e) => {
      if (e > 0) {
        i.remove();
      }
    });
  }

  let ScrollDown = document.getElementsByClassName("js-scrolldown");
  if (ScrollDown.length > 0) {
    ScrollDown[0].addEventListener("click", function () {
      animateto("intro");
    });
  }

  //FAQ
  setTimeout(function () {
    $(".tab-label").each(function () {
      let thisHeightTap = $(this).height() + 44;
      let thisHeight = $(this).next(".tab-content").height() + thisHeightTap;
      $(this)
        .parent()
        .animate({ height: thisHeightTap + "px" }, 400);
      if ($(this).hasClass("open")) {
        $(this)
          .parent()
          .animate({ height: thisHeight + "px" }, 400);
      }
    });
    $(".learn-more-btn").append('<div class="arrow"></div>');
  }, 400);

  $(".tab-label").click(function () {
    let currentclick = $(this);
    let thisHeightTap = $(this).height() + 44;

    let slideIndex = $(this).data("artwork");
    $(".accordion-slide").slick("slickGoTo", parseInt(slideIndex));

    if (!currentclick.hasClass("open")) {
      $(".tab-label").each(function () {
        if ($(this) !== currentclick) {
          if ($(this).hasClass("open")) {
            let thisHeight = $(this).height() + 44;
            $(this).removeClass("open");
            $(this)
              .parent()
              .animate({ height: thisHeight + "px" }, 400);
          }
        }
      });
      currentclick.addClass("open");
      let thisHeight = $(this).next(".tab-content").height() + thisHeightTap;
      $(this)
        .parent()
        .animate({ height: thisHeight + "px" }, 400);
    } else {
      currentclick.removeClass("open");
      currentclick.parent().animate({ height: thisHeightTap + "px" }, 400);
    }
  });

  $("[data-fancybox]").fancybox({
    loop: true,
  });

  $("a[href^='#']:not(a[data-fancybox])").click(function (e) {
    e.preventDefault();
    let strAncla = $(this).prop("hash").substr(1);
    animateto(strAncla);
  });

  let screenHeight = $(window).height();
  $("#home .top-img figure, #home .top-img video").css("height", screenHeight);

  $(window).resize(function () {
    screenHeight = $(window).height();
    $("#home .top-img figure, #home .top-img video").css(
      "height",
      screenHeight
    );
  });

  $("#loader-wrapper")
    .delay(6200)
    .fadeOut("hide", function () {
      $(this).addClass("hiden");
    });

  if ($.cookie("loader-wrapper") == null) {
    $("#loader-wrapper").show();
    $.cookie("loader-wrapper", true);
  } else {
    $("#loader-wrapper").hide().addClass("hiden");
  }

  const SCROLL_PARAMS$1 = "post";
  const SCROLL_PARAMS$2 = "link";

  // scrollToSearch
  // * Simulate clic in item facybox by search params
  const scrollToSearch = () => {
    if (window.location.search) {
      const url = window.location.search.slice(1);
      if (url === null) return null;

      // * Decode URL Base64
      let decodeURL = atob(url);
      // * Search params
      const urlParams = new URLSearchParams(decodeURL);
      const post = urlParams.get(SCROLL_PARAMS$1);
      const link = urlParams.get(SCROLL_PARAMS$2);
      let target;
      if (post !== null) {
        target =
          document.querySelector(post) !== null
            ? document.querySelector(post)
            : null;
        console.log(post);
        if (target) {
          $("html, body").animate(
            { scrollTop: $(target).offset().top - 0 },
            800
          );

          setTimeout(() => {
            if (link !== null) {
              target = document.querySelector(link);
              if (target) {
                target.click();
              }
            }
          }, 800);
        }
      }
    }
    return null;
  };

  const onDOMLoaded = (callback) => {
    if (
      document.readyState === "complete" ||
      document.readyState === "interactive"
    ) {
      document.addEventListener("DOMContentLoaded", () => {
        setTimeout(callback, 1);
      });
    } else {
      document.addEventListener("DOMContentLoaded", callback);
    }
  };

  onDOMLoaded(scrollToSearch());



  // URL SCROLL FUNCTIONALITY

  // function scrollElementByQuadParam(url) {
  //   const parsedURL = new URL(url);
  //   const quadValue = parsedURL.searchParams.get("quad");
  //   const targetValue = parsedURL.searchParams.get("target");

  //   console.log( { quadValue, targetValue } );
  
  //   if (quadValue) {
  //     const elementToScroll = document.getElementById(quadValue);
  
  //     if (elementToScroll) {
  //       // Calculate the position to scroll to (subtract 100 pixels from the element's top position)
  //       const scrollToPosition = elementToScroll.getBoundingClientRect().top - 100;
  //       // Scroll to the calculated position
  //       window.scrollTo({
  //         top: window.scrollY + scrollToPosition,
  //         behavior: "smooth"
  //       });

  //       // if( document.querySelector( `#${ targetValue }` )) {
  //       //   document.getElementById(targetValue).click();
  //       // }

  //     } else {
  //       console.log("No element with the provided 'quad' parameter value was found.");
  //     }
  //   } else {
  //     console.log("The 'quad' parameter is not present in the URL.");
  //   }
  // }

  document.addEventListener('DOMContentLoaded', () => {
    if( document.getElementById('email-signup') ){
      let selectorCountrySignupForm = document.getElementById('email-signup_country') ? document.getElementById('email-signup_country') : document.querySelector('select#country'),
          selectorStateSignupForm = document.getElementById('email-signup_state') ? document.getElementById('email-signup_state') : document.getElementById('select#state');

      if( selectorCountrySignupForm && selectorStateSignupForm ){
        selectorCountrySignupForm.addEventListener('change', () => {
          if( selectorCountrySignupForm.value != 'US' ){
            selectorStateSignupForm.value = '';
            selectorStateSignupForm.setAttribute('disabled', 'true');
          }else{
            selectorStateSignupForm.removeAttribute('disabled')
          }
        });
      }
    }

  });

})();

/*function animateto(target) {
  var gotoTarget = offset(document.getElementById(target)).top - 120;
  var from = window.pageYOffset;
  var to = gotoTarget;
  var duration = 1300;
  var start = new Date().getTime();

  //time interval
  var timer = setInterval(function () {
    var time = new Date().getTime() - start;

    if (from <= to) {
      var y = easeInOutQuart(time, from, to - from, duration);
    } else {
      var y = easeInOutQuart(time, from, -(from - to), duration);
    }
    window.scrollTo(0, y);
    if (time >= duration) clearInterval(timer);
  }, 1000 / 60);

  window.scrollTo(0, from);
}
//ease movement
function easeInOutQuart(t, b, c, d) {
  if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
  return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}*/

$(document).ready(function () {
  //To create after event
  $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
  $.datepicker._updateDatepicker = function (inst) {
    $.datepicker._updateDatepicker_original(inst);
    var afterShow = this._get(inst, "afterShow");
    if (afterShow) afterShow.apply(inst.input ? inst.input[0] : null); // trigger custom callback
  };
  $("#arriveInput").on("change", function () {
    start = $(this).val();
    $(".calendar-block").datepicker("setDate", start);
  });
  $("#departureInput").on("change", function () {
    end = $(this).val();
    $(".calendar-block").datepicker("setDate", end);
  });

  $(".calendar-block").datepicker({
    changeMonth: false,
    dateFormat: "mm/dd/yy",
    numberOfMonths: 2,
    minDate: 0,

    beforeShowDay: function (date) {
      setTimeout(function() {
        document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
          e.setAttribute('tabindex', '-1');
        })
      }, 1000);

      $.datepicker._defaults.dateFormat = "mm/dd/yy";
      var startDate = $.datepicker.parseDate(
        $.datepicker._defaults.dateFormat,
        start
      );
      var endDate = $.datepicker.parseDate(
        $.datepicker._defaults.dateFormat,
        end
      );
      if (date.getTime() == startDate.getTime()) {
        return [true, "startday"];
      } else {
        if (date.getTime() == endDate.getTime()) {
          return [true, "endday"];
        } else {
          if (
            date.getTime() > startDate.getTime() &&
            date.getTime() < endDate.getTime()
          ) {
            return [true, "days"];
          } else {
            return [true, ""];
          }
        }
      }
    },
    onSelect: function (date) {
      var arrive = $.datepicker.parseDate(
        $.datepicker._defaults.dateFormat,
        start
      );
      var departure = $.datepicker.parseDate(
        $.datepicker._defaults.dateFormat,
        end
      );
      var selectedDate = $.datepicker.parseDate(
        $.datepicker._defaults.dateFormat,
        date
      );

      if (opened == 0) {
        opened = 1;
        start = date;
        end = date;
        opencheck = 0;
      } else {
        opened = 0;
        if (selectedDate <= arrive) {
          end = start;
          start = date;
        } else {
          end = date;
        }
        $("#fakeInput").fadeOut();
        opencheck = 1;
        firstClick = 0;
      }

      $("#arriveInput").attr("value", start);
      $("#departureInput").attr("value", end);
      $("#arrive_depart").attr("value", start + " - " + end);
    },
    onChangeMonthYear: function () {
      opencheck = 1;
    },
  });

  // Map: Return to previous page button. Change body id to match map template's name.
  //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
});

(function() {
  /** ADA Tab Links Functionality for Keyboard Navigation in Booking **/

  function updateMenuTabIndex() {
    const menu = document.querySelector('#bookingBox');
    const isMenuVisible = menu && menu.classList.contains('open');
    const elements = document.querySelectorAll('#btn-close, .form input, .select-item select, .promo_code, .bookNow, .text-best a');
    
    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });

    if (isMenuVisible) {
        const closeButton = document.querySelector('#btn-close');
        if (closeButton && !closeButton.classList.contains('focused')) {
            closeButton.focus();
            closeButton.classList.add('focused');
        }
    } else {
        const closeButton = document.querySelector('#btn-close');
        if (closeButton) {
            closeButton.classList.remove('focused');
        }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex); 
    
    const menu = document.querySelector('#bookingBox');
    let BtnReserve = document.getElementById("js_btn_book");

    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
    
    if(menu && BtnReserve){
      BtnReserve.addEventListener('click', () => {
        if (menu.classList.contains('open')){
          document.addEventListener('keydown', (event) => {
            if(event.key === 'Escape'){
              menu.classList.remove('open');
            }
          });
        }
      });
    }
  });

  /** Accessibility Adjustment for All Slides **/

  $(document).ready(function() {
    $('.sym-slides').on('beforeChange', function(event, slick, currentSlide, nextSlide) {

      var slides = $(slick.$slides);
      slides.each(function() {
          var slide = $(this);
          if (slide.attr('aria-hidden') === 'true') {
              slide.attr('tabindex', '-1');
          } else {
              slide.attr('tabindex', '0');
          }
      });

      $(slick.$slides.eq(nextSlide)).attr('tabindex', '0');
  });

  });
})();










